export const Bio = {
  name: "Filbert Leonardo",
  roles: ["Data Scientist", "Data Analyst"],
  description:
    "I am a data-driven enthusiast with a passion for uncovering insights and solving complex problems. Eager to embrace new challenges, I approach each task with curiosity and a commitment to excellence. My growth mindset and determination empower me to deliver impactful results and contribute effectively to any project.",
  github: "https://github.com/filbertleo88",
  resume: "https://drive.google.com/file/d/12vy0aZv5qwpLLPrX1TxDsGE-62CspjA0/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/filbert-leonardo",
  insta: "https://www.instagram.com/filbert.leonardo/",
};

export const skills = [
  {
    title: "Artificial Intelligence",
    skills: [
      {
        name: "Python",
        image: "https://icon.icepanel.io/Technology/svg/Python.svg",
      },
      {
        name: "R",
        image: "https://icon.icepanel.io/Technology/svg/R-.svg",
      },
      {
        name: "Pandas",
        image: "https://icon.icepanel.io/Technology/png-shadow-512/Pandas.png",
      },
      {
        name: "Numpy",
        image: "https://icon.icepanel.io/Technology/svg/NumPy.svg",
      },
      {
        name: "Scikit-learn",
        image: "https://icon.icepanel.io/Technology/svg/scikit-learn.svg",
      },
      {
        name: "Tensorflow",
        image: "https://icon.icepanel.io/Technology/svg/TensorFlow.svg",
      },
      {
        name: "Keras",
        image: "https://icon.icepanel.io/Technology/svg/Keras.svg",
      },
    ],
  },
  {
    title: "Data Visualization",
    skills: [
      {
        name: "Matplotlib",
        image: "https://icon.icepanel.io/Technology/svg/Matplotlib.svg",
      },
      {
        name: "Seaborn",
        image: "https://www.educative.io/api/edpresso/shot/5096396179374080/image/5300591913336832",
      },
      {
        name: "Plotly",
        image: "https://icon.icepanel.io/Technology/svg/Ploty.svg",
      },
      {
        name: "Streamlit",
        image: "https://icon.icepanel.io/Technology/svg/Streamlit.svg",
      },
      {
        name: "Tableau",
        image: "https://www.edureka.co/blog/wp-content/uploads/2018/01/tableau-icon-what-is-tableau-blog-edureka.png",
      },
      {
        name: "Google Looker Studio",
        image: "https://seeklogo.com/images/G/google-looker-logo-B27BD25E4E-seeklogo.com.png",
      },
      {
        name: "Power BI",
        image: "https://logohistory.net/wp-content/uploads/2023/05/Power-BI-Logo.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image: "https://www.svgrepo.com/show/373535/css.svg",
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "React",
        image: "https://www.pngall.com/wp-content/uploads/15/React-Logo-PNG-Images.png",
      },
      {
        name: "Next JS",
        image: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/nextjs-icon.png",
      },
      {
        name: "Tailwind CSS",
        image: "https://cdn.builder.io/api/v1/image/assets/YJIGb4i01jvw0SRdL5Bt/8d0b6724f6f6496dbf124bfc3af2a0b0",
      },
      {
        name: "TypeScript",
        image: "https://logospng.org/download/typescript/typescript-4096.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PHP",
        image: "https://icon.icepanel.io/Technology/svg/PHP.svg",
      },
      {
        name: "Firebase",
        image: "https://icon.icepanel.io/Technology/svg/Firebase.svg",
      },
      {
        name: "BigQuery",
        image: "https://www.svgrepo.com/show/375551/bigquery.svg",
      },
      {
        name: "DBeaver",
        image: "https://icon.icepanel.io/Technology/svg/DBeaver.svg",
      },
      {
        name: "MongoDB",
        image: "http://pluspng.com/img-png/logo-mongodb-png-mongodb-1600.png",
      },
      {
        name: "Node JS",
        image: "http://pluspng.com/img-png/nodejs-png-nodejs-icon-png-50-px-1600.png",
      },
      {
        name: "Socket IO",
        image: "https://miro.medium.com/v2/resize:fit:800/1*zt3z3tHc_99hFvpIQusc6Q.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image: "https://icon.icepanel.io/Technology/svg/Java.svg",
      },
      {
        name: "Android Studio",
        image: "https://icon.icepanel.io/Technology/png-shadow-512/Android-Studio.png",
      },
    ],
  },
  {
    title: "Design",
    skills: [
      {
        name: "Canva",
        image: "https://icon.icepanel.io/Technology/svg/Canva.svg",
      },
      {
        name: "Figma",
        image: "https://icon.icepanel.io/Technology/svg/Figma.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://icon.icepanel.io/Technology/svg/Git.svg",
      },
      {
        name: "GitHub",
        image: "https://www.svgrepo.com/show/353783/github-octocat.svg",
      },
      {
        name: "Google Colab",
        image: "https://pbs.twimg.com/profile_images/1330956917951270912/DyIZtTA8_400x400.png",
      },
      {
        name: "KNIME",
        image: "https://quantumanalytics.ch/wordpress/wp-content/uploads/2017/10/KNIME_logo.png",
      },
      {
        name: "Pycharm",
        image: "https://icon.icepanel.io/Technology/svg/PyCharm.svg",
      },
      {
        name: "RStudio",
        image: "https://icon.icepanel.io/Technology/svg/RStudio.svg",
      },
      {
        name: "VS Code",
        image: "https://icon.icepanel.io/Technology/svg/Visual-Studio-Code-%28VS-Code%29.svg",
      },
      {
        name: "Postman",
        image: "https://icon.icepanel.io/Technology/svg/Postman.svg",
      },
      {
        name: "Trello",
        image: "https://logos-world.net/wp-content/uploads/2021/02/Trello-Emblem.png",
      },
      {
        name: "Notion",
        image: "https://logos-world.net/wp-content/uploads/2024/08/Notion-Logo.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 22,
    img: "https://elice.io/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Felice_logo.06b34994.png&w=256&q=75",
    role: "Software Developer",
    company: "Elice",
    date: "Sep 2025 - Nov 2025",
    desc: "I participated in the Korean Asia Development Academy program under Elice, where I developed multiple full-stack web applications using Next.js, React, and MongoDB. I built a responsive food ordering website with real-time order tracking and a bulletin board platform enabling CRUD operations. I also led a 6-member team to create LISN, an AI-powered meeting assistant integrating Whisper, Gemini, and GPT for real-time transcription, summarization, and sentiment analysis.",
    skills: ["Next.js", "React", "TypeScript", "MongoDB", "Node.js", "Whisper", "Gemini", "GPT", "AI Integration", "Team Leadership"],
    doc: ["https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/KADA_Elice_Certificate.png?alt=media&token=7b75755a-48a0-41e7-9b52-a28a4b8a5335"],
  },
  {
    id: 22,
    img: "https://media-exp1.licdn.com/dms/image/C4D0BAQFoAYMB13p2Vg/company-logo_200_200/0/1633704405224?e=2147483647&v=beta&t=POFJHBJQgSnsaA29VOXVoyyQOngRmVP2s9E9zEJ39nM",
    role: "Data Analyst",
    company: "Digital Talent Scholarship x DQLab",
    date: "Jul 2025 - Sep 2025",
    desc: "I completed the Data Analyst Learning Program by DQLab in collaboration with Komdigi, where I built a strong foundation in Python, SQL, and data visualization through hands-on, project-based learning. I gained practical experience in exploratory data analysis, business analytics, and financial/operational evaluation—ranging from user behavior mapping and funnel conversion analysis to margin impact and stock risk assessment. I applied these analytical skills to solve real-world business cases, strengthening my ability to transform data into actionable insights for decision-making.",
    skills: ["Python", "SQL", "Data Visualization", "Exploratory Data Analysis", "Business Analytics", "Financial Analysis", "Operational Analysis"],
    doc: [
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Fundamental%20of%20Data%20Analyst.png?alt=media&token=2381a089-9e0d-4d91-b273-89527c75b662",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Practical%20Real%20Business%20Application%20for%20Business%20Intelligence%20Analyst.png?alt=media&token=46b88c6f-8e88-4108-962b-6c89e837ac9d",
    ],
  },
  {
    id: 0,
    img: "https://companieslogo.com/img/orig/UDMY_BIG.D-125629a7.png?t=1720244494",
    role: "Skills Developer",
    company: "Udemy",
    date: "Jan 2025 - Now",
    desc: "I completed multiple Excel-focused courses on Udemy, gaining end-to-end proficiency in spreadsheet-based data management, automation, and reporting. These courses covered advanced functions, dynamic dashboards, and Excel-based data analysis used in business operations and supply chain contexts. Through hands-on projects, I learned to automate workflows, build interactive reports, and analyze large datasets using functions like VLOOKUP, INDEX-MATCH, and Power Query. I also applied Excel to solve real-world problems in inventory control and business intelligence, preparing me for data-driven roles in operations and analytics.",
    skills: [
      "Advanced Excel Functions (VLOOKUP, INDEX-MATCH, IF, SUMIFS, COUNTIFS)",
      "Pivot Tables & Pivot Charts",
      "Power Query & Power Pivot",
      "Macro & VBA Scripting",
      "Inventory & Supply Chain Data Management",
      "Excel Dashboards",
      "Data Cleaning & Transformation",
      "Spreadsheet-Based Automation",
    ],
    doc: [
      "https://udemy-certificate.s3.amazonaws.com/image/UC-560d682f-225f-4754-ae65-f9ad58535133.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-d85601b8-6c54-48c3-84c0-e67cf4468f09.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-7db43738-564b-4653-80d3-f4276622da8d.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-fa9b8c24-67f5-4419-835c-e9e55cf30d87.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-faf8efd3-24c2-4173-86f1-2701c7eaf71a.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-6309e9c3-c889-4019-9e7c-ae8b7aac6b4a.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-c80aef2e-d02d-4487-b37d-d9cb525e6b1a.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-4a764601-1069-4e49-8714-010c97d3afda.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-aba16b1c-c4ba-476e-91e3-12bb93e2b1ec.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-6b393d2c-77cc-453d-8461-d23d4ecbcc60.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-b50cd3d4-0620-483e-98cf-fba588252e57.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-4f4acdf4-0c07-405a-853f-f0bf99d663f0.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-e9e0f650-b6d7-44a2-85d9-566855e96cf9.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-220687b3-12ba-4933-8b19-8ce3fd7f7e9b.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-895c2c7a-440b-47f9-aa12-7f4adef7d2bf.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-12924229-044b-4614-b34f-fddfc8013806.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-47cdbc3b-3b5d-4760-8abd-3ca9cf618a38.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-5a785040-ec5e-47ca-830b-06d7dfebbf41.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-f02b015a-fef3-47f1-887f-3c4ae1098383.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-5af6df63-2d69-4123-93c0-85dfb395c30f.jpg",
      "https://udemy-certificate.s3.amazonaws.com/image/UC-bf67fe37-9fcb-43df-9881-cb808982a3fd.jpg",
    ],
  },
  {
    id: 1,
    img: "https://i.ytimg.com/vi/UYZp1wWmhSk/maxresdefault.jpg",
    role: "Data Science",
    company: "GreatEdu",
    date: "Feb 2024 - Jun 2024",
    desc: "I completed an intensive Data Science program at GreatEdu, where I honed advanced skills in data wrangling, machine learning, and data visualization. As a selected participant in the prestigious Studi Independen Kampus Merdeka program, I excelled in all quizzes and hands-on projects, earning recognition as the best student. My capstone project involved developing a predictive dashboard for air quality in Seoul, with a focus on AQI classification and particulate matter forecasting. Additionally, I achieved KNIME and BNSP certifications, further validating my expertise in data science.",
    skills: ["Python", "Statistic", "Database", "DBeaver", "Data Preprocessing", "Data Exploration", "Data Visualization", "Machine Learning", "KNIME", "Postman", "Streamlit"],
    doc: [
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/BNSP%20Associate%20Data%20Scientist.png?alt=media&token=79eb6cf5-a133-43f4-a535-0e6af44a3da9",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/BNSP-Data%20Science.jpg?alt=media&token=66683983-3839-4656-9bc4-fc1a27c8e21e",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/KNIME.jpg?alt=media&token=24164d17-1183-4965-b163-00cff7b0e89d",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/GreatEdu.jpg?alt=media&token=5c798e4d-38b0-43b6-955e-c9b99f69bbc3",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/MSIB6.jpg?alt=media&token=c8fbbff9-1c49-4430-8fac-0e9fea6e4e21",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/DEPA.png?alt=media&token=63be2760-449d-42d2-ad11-d1ad4da523a9",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/KLHK.png?alt=media&token=e195572f-8825-48b2-b14a-0cb0754be091",
    ],
  },
  {
    id: 2,
    img: "https://s3-ap-southeast-1.amazonaws.com/revou-blog/2019/12/Logo-RevoU-5.png",
    role: "Data Analyst",
    company: "RevoU",
    date: "Jan 2024 - Jan 2024",
    desc: "I successfully completed the RevoU Data Analytics Mini Course, where I gained hands-on experience in data analysis techniques, including extracting, transforming, and analyzing data using SQL. The course also strengthened my data visualization skills through designing and building dashboards with Tableau and Power BI. For my final project, I created a Tableau dashboard that provided insights into population and healthcare facilities in West Java, showcasing my ability to transform data into actionable insights.",
    skills: ["Python", "Database", "BigQuery", "Data Exploration", "Data Visualization", "Microsoft BI", "Looker Studio", "Tableau"],
    doc: ["https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/RevoU.jpg?alt=media&token=3c99ded2-83c6-4980-b56b-d6aaff5dee5c"],
  },
  {
    id: 3,
    img: "https://media-exp1.licdn.com/dms/image/C4D0BAQFoAYMB13p2Vg/company-logo_200_200/0/1633704405224?e=2147483647&v=beta&t=POFJHBJQgSnsaA29VOXVoyyQOngRmVP2s9E9zEJ39nM",
    role: "Data Science",
    company: "Digital Talent Scholarship",
    date: "Sep 2023 - Nov 2023",
    desc: "I participated in the Talent Scouting Academy (TSA), a prestigious program under the 'Merdeka Belajar Kampus Merdeka' initiative, where I was selected from hundreds of applicants. As the top performer, I demonstrated strong analytical and technical abilities by developing a Rainfall-based Flood Monitoring and Prediction Dashboard for Cilacap District. This project involved applying advanced data science and machine learning techniques to address real-world challenges, enhancing flood preparedness and mitigation efforts through innovative data-driven solutions.",
    skills: ["R", "TidyVerse", "Data Exploration", "Machine Learning", "Deep Learning", "Time Series"],
    doc: [
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/DTS%20TSA.jpg?alt=media&token=5740538b-49f3-45e8-937b-36edf156e48b",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/TSA%20Peserta%20Terbaik.jpg?alt=media&token=5c5a2b3a-2a56-47c3-8979-3dc1ee9981ea",
    ],
  },
  {
    id: 4,
    img: "https://dicoding-web-img.sgp1.cdn.digitaloceanspaces.com/original/commons/bangkit-logo.png",
    role: "Machine Learning",
    company: "Bangkit Academy led by Google, Tokopedia, Gojek, & Traveloka",
    date: "Feb 2023 - Jul 2023",
    desc: "I completed the Bangkit program, an MSIB initiative by Google and leading Indonesian tech companies, where I was selected for the Machine Learning cohort. Throughout the program, I achieved high distinction in all quizzes, demonstrating a solid grasp of machine learning principles. I contributed to a Digital Government Transformation capstone project, playing a key role in developing the 'Interstate Now' app, which provides real-time toll road rest area information. Additionally, I earned a global TensorFlow certification, validating my practical skills in machine learning and contributing to innovative transportation management solutions.",
    skills: [
      "Python",
      "Algorithm",
      "Mathematics",
      "Data Preprocessing",
      "Data Exploration",
      "Data Visualization",
      "Machine Learning",
      "Deep Learning",
      "Object Detection",
      "Natural Language Processing",
      "Time Series",
      "Tensorflow",
      "Keras",
    ],
    doc: [
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Bangkit.jpg?alt=media&token=f0372f44-d212-42d0-b093-65bde849b3c0",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Tensorflow.jpg?alt=media&token=19de37a5-c3b1-4360-b884-2cc8e85db250",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Dicoding-Memulai%20Dasar%20Pemograman.jpg?alt=media&token=f72aa928-289d-4dfe-af33-210777623226",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Dicoding-Pengenalan%20Logika.jpg?alt=media&token=0e889693-4030-4886-b08b-3c3ca2c00ec7",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Dicoding-Belajar%20Dasar%20Git.jpg?alt=media&token=094ba731-314f-40e0-bd72-236b6091a9d4",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Data%20Analytics.jpg?alt=media&token=1c44a1d4-4c9a-4cfe-a906-2704d406f351",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-IT%20Automation.jpg?alt=media&token=1e5a244c-6126-4ed6-b781-e785f975aeb0",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-ML.jpg?alt=media&token=f81048d4-a067-4c05-8669-c9519095e155",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Mathematics%20for%20ML.jpg?alt=media&token=10928b7d-0108-4f2a-bde7-b432227676fd",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Deep%20Learning%20Tensorflow.jpg?alt=media&token=3c371a7c-34cf-4a83-9ad1-cef7cad071c6",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Tensorflow%20Advanced.jpg?alt=media&token=5d74d450-3ed6-4f7e-855d-6df573168989",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Tensorflow%20Data%20Deployment.jpg?alt=media&token=e7a87e1b-e9c5-4c9d-bf39-0ce10842aa14",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Natural%20Language%20Processing.jpg?alt=media&token=99528c5a-1ec5-47b5-b7de-20090883dc9c",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Coursera-Strcuturing%20ML%20Projects.jpg?alt=media&token=8bb7a18c-9ff5-47e6-9920-018552f98835",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/English%20Toefl.png?alt=media&token=844529b0-4635-4c78-8600-6beafb14e08d",
    ],
  },
  {
    id: 5,
    img: "https://tse4.mm.bing.net/th?id=OIP.dqEtqDewluC_9BKNpLw96gHaEH&pid=Api&P=0&h=180",
    role: "Data Analyst",
    company: "Baparekraf Digital Talent",
    date: "Oct 2022 - Dec 2022",
    desc: "I was selected from thousands of applicants to participate in the Baparekraf Digital Talent program, where I gained in-depth knowledge and practical expertise in data analytics. Through this program, I completed all quizzes and earned a Coursera certification, showcasing my proficiency in data interpretation, statistical analysis, and the use of advanced tools. My experience in the program reflects my commitment to continuous learning and staying current with industry trends, positioning me as a skilled Data Analyst in the digital economy.",
    skills: ["Python", "Database", "Data Exploration", "Data Visualization", "BigQuery", "Spreadsheet"],
    doc: ["https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/BDT%20-%20Data%20Analyst.jpg?alt=media&token=6bcae4fb-292e-49d3-992a-4d6b6471d689"],
  },
  {
    id: 6,
    img: "https://media-exp1.licdn.com/dms/image/C4D0BAQFoAYMB13p2Vg/company-logo_200_200/0/1633704405224?e=2147483647&v=beta&t=POFJHBJQgSnsaA29VOXVoyyQOngRmVP2s9E9zEJ39nM",
    role: "Web Development",
    company: "Junior Web Developer",
    date: "Jul 2022 - Aug 2022",
    desc: "I participated in the Vocational School Graduate Academy (VSGA) by Kominfo Junior, Web Developer program, where I was selected from hundreds of applicants to gain comprehensive training in web development. Through the program, I successfully completed all tasks and quizzes, earned a Junior Web Programming certification from BNSP, and developed a student registration website featuring a robust CRUD system as my final project. This experience has solidified my skills in both front-end and back-end development, preparing me for a career in web development.",
    skills: ["HTML", "CSS", "Javascript", "Algorithm", "Database", "MySQL", "Hosting"],
    doc: [
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/DTS%20VSGA.jpg?alt=media&token=89f7e02b-509a-4e40-8f06-ddaa0f468e13",
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/BNSP%20-%20Junior%20Web%20Developer.jpg?alt=media&token=fa8ddb1e-c59b-474e-a734-84c7e3138ee5",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://eventkampus.com/data/sekolah/70-8.jpeg",
    school: "Sari Mutiara Indonesia University, North Sumatera",
    date: "Sep 2020 - Sep 2024",
    grade: "3.95",
    desc: "I graduated with a Bachelor's degree in Information Systems from Universitas Sari Mutiara Indonesia, achieving a GPA of 3.96. Throughout my studies, I completed various courses that strengthened my foundation in the field, including Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, among others. Beyond my formal education, I actively participated in several training programs outside of campus, such as the MSIB and Digitalent programs, which aligned with my deep interest in Artificial Intelligence and databases. These experiences have equipped me with the skills and knowledge necessary to excel in the evolving tech industry.",
    degree: "Bachelor of Information System",
  },
  {
    id: 1,
    img: "https://sokrates.id/wp-content/uploads/2021/02/WR-Supratman.png",
    school: "Wage Rudolf Supratman 1 School, North Sumatera",
    date: "Jun 2017 - Jun 2020",
    grade: "92.31",
    desc: "I completed my high school at Wage Rudolf Supratman 1. My passion for mathematics and algorithms led me to participate in an extracurricular programming class with Binus, where I further developed my problem-solving skills and deepened my understanding of coding. This experience reinforced my interest in technology and laid a strong foundation for my future studies in the field.",
    degree: "Science Class",
  },
];

export const projects = [
  {
    id: 22,
    title: "LISN (Listen, Interpret, Summarize, Narrate) ",
    date: "Sep 2025 - Nov 2025",
    description:
      "Developed an AI-powered meeting documentation system that solves the problem of inefficient meeting documentation. Instead of manually taking notes, LISN automatically transcribes audio, generates summaries, extracts action items, and analyzes meeting sentiment in real-time. This allows participants to focus on the discussion rather than note-taking, while ensuring nothing important is missed.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/LISN.png?alt=media&token=97c174fb-dfe6-4bec-8282-7b3c6b2fd2d5",
    tags: ["React", "Next JS", "Typescript", "Tailwind", "MongoDB", "Node JS", "Socket IO", "Whisper", "GPT-5", "Gemini"],
    category: "web",
    github: "https://github.com/filbertleo88/lisn.git",
    slide: "https://www.canva.com/design/DAG3hNflvyA/e1gtHO1vojy6Yh3KD9h9zg/view?utm_content=DAG3hNflvyA&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hf8187b4032",
    webapp: "https://drive.google.com/file/d/1LaHcilyZ4hRyBU6vqAhI8SBw77FCMk9U/view?usp=sharing",
    member: [
      {
        name: "Filbert Leonardo",
        img: "https://avatars.githubusercontent.com/u/101468273?v=4",
        linkedin: "https://www.linkedin.com/in/filbert-leonardo/",
        github: "https://github.com/filbertleo88",
      },
      {
        name: "Muhammad Alif Shelviano",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFU3erFXP0VMw/profile-displayphoto-crop_800_800/B56ZgOMbH0GUAM-/0/1752584798635?e=1764806400&v=beta&t=PBhgYJrTXM46qMesG2MHgTg9MFp3LGRNYJAViag17nE",
        linkedin: "https://www.linkedin.com/in/alifshelviano/",
        github: "https://github.com/alifshelviano",
      },
      {
        name: "Muhammad Farhan",
        img: "https://media.licdn.com/dms/image/v2/D5603AQELQ85w3oU-NQ/profile-displayphoto-crop_800_800/B56Zpj7LzDI4AI-/0/1762613054235?e=1764806400&v=beta&t=-SWagyXgIcF1aFr0Ic02HO5M5R5KGDiyFuwZ5TlZHhw",
        linkedin: "https://www.linkedin.com/in/muhammad-farhan-337787261/",
      },
      {
        name: "Bagas Dwiprasandi",
        img: "https://media.licdn.com/dms/image/v2/D5635AQEnDAq0QGP0Bw/profile-framedphoto-shrink_800_800/B56ZlwLZJLHQAk-/0/1758523659217?e=1763521200&v=beta&t=oXInlORUsPlMs6XCt-AAt_L_cfi6jU4qqF-LMLB7JDQ",
        linkedin: "https://www.linkedin.com/in/bagasdprs/",
      },
      {
        name: "Riyan Wahyu Prasetyo",
        img: "https://media.licdn.com/dms/image/v2/D5603AQG9iZ2CloSUug/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1732887417472?e=1764806400&v=beta&t=ljmkW_tSPdhhXqi_aGoIVKNGWz3BGyhnuauswa3MzyM",
        linkedin: "https://www.linkedin.com/in/riyanwahyuprasetyo/",
      },
      {
        name: "Gladys Aisyah",
        img: "https://media.licdn.com/dms/image/v2/D4E03AQEftoaCIdu7gA/profile-displayphoto-shrink_800_800/B4EZZYyrMqHYAs-/0/1745246402091?e=1764806400&v=beta&t=5C26Q0pAOShzKbteyxSQdsjXX_3gEN2fl-7LBR1RhA8",
        linkedin: "https://www.linkedin.com/in/gladys-aisha-9218a1224/",
      },
    ],
  },
  {
    id: 23,
    title: "Inskpire Blog Website",
    date: "Oct 2025 - Nov 2025",
    description:
      "Inskpire is a feature-rich blogging platform that empowers content creators with a modern, intuitive interface. The application includes user authentication with Google OAuth, a rich text editor for post creation, tagging system for content organization, real-time search functionality, and interactive features like comments and likes. Built with a responsive design using Tailwind CSS, it offers an optimal viewing experience across all devices while maintaining fast performance with server-side rendering capabilities.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Inskpire%20Homepage.png?alt=media&token=d786c1c5-568b-4fc7-ba5b-3e623ebb8f7c",
    tags: ["React", "Next JS", "Typescript", "Tailwind", "MongoDB", "Node JS"],
    category: "web",
    github: "https://github.com/filbertleo88/inkspire-blog-app.git",
    webapp: "https://inskpire-blog-app.vercel.app/",
  },
  {
    id: 0,
    title: "Seoul AQI Prediction",
    date: "Mar 2024 - Jun 2024",
    description:
      "Developed a Streamlit web dashboard application focused on predicting air quality index (AQI) levels in Seoul using an Artificial Intelligence model. The application leverages historical data and various environmental factors to forecast AQI, providing users with many insights and future air quality predictions. This tool is designed to help residents and authorities in Seoul make informed decisions about outdoor activities and public health initiatives based on predicted air quality trends.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Seoul%20AQI%20Prediction.png?alt=media&token=b641c9b8-efd3-4d8c-b40e-760d57563976",
    tags: ["Python", "Sklearn", "Plotly", "Folium", "Pickle", "Tensorflow", "Keras", "Streamlit"],
    category: "ai",
    github: "https://github.com/filbertleo88/GreatEdu-Final-Project---Air-Quality-Seoul-Analysis-dan-Prediction",
    slide: "https://www.canva.com/design/DAGoKeHAs3I/LNTpWBpwKOEZIQVSb7xRHQ/view?utm_content=DAGoKeHAs3I&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h2b429f59c4",
    webapp: "https://greatedu-final-project---air-quality-seoul-analysis-dan-predic.streamlit.app/",
    member: [
      {
        name: "Filbert Leonardo",
        img: "https://avatars.githubusercontent.com/u/101468273?v=4",
        linkedin: "https://www.linkedin.com/in/filbert-leonardo/",
        github: "https://github.com/filbertleo88",
      },
      {
        name: "Sitanggang Immanuel",
        img: "https://avatars.githubusercontent.com/u/93606416?v=4",
        linkedin: "https://www.linkedin.com/in/sitanggang-immanuel-urat-mangido-tua/",
        github: "https://github.com/elltot",
      },
      {
        name: "Deri Rizky Nugraha",
        img: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        linkedin: "https://www.linkedin.com/in/deri-rizky-nugraha-18876b2a3/",
      },
      {
        name: "Anas Putra Agazy",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQGBSNvOLEE2Mg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1701488741099?e=1730332800&v=beta&t=b_kS23gKxPJjUMNQgbt6-Kh-WcXmut_V8aqBRbQsnoA",
        linkedin: "https://www.linkedin.com/in/anas-putra-agazy-4192142a3/",
      },
    ],
  },
  {
    id: 2,
    title: "Virtual Assistant Portfolio",
    date: "June 2025",
    description:
      "A curated portfolio showcasing my skills as a Virtual Assistant, covering key areas such as administrative support, email and calendar management, data entry, project coordination using Trello and Notion, and social media management with tools like Buffer, Canva, and Mailchimp. This project highlights my ability to organize workflows, streamline communication, and support business operations efficiently through real-world examples and automation.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Filbert's%20Virtual%20Assistant%20Portfolio.png?alt=media&token=7e84926a-8f86-419a-b279-8efa2b1e1e41",
    tags: ["Virtual Assistant", "Administrative Support", "Project Management", "Data Entry", "Social Media Management"],
    category: "excel",
    slide: "https://www.canva.com/design/DAGrWhNco0k/5CZrs4ZInFljLnvjJ-ElSA/view?utm_content=DAGrWhNco0k&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h8912018530",
  },
  {
    id: 18,
    title: "Inventory Management System (FIFO) using Excel",
    date: "Apr 2025",
    description:
      "Developed an automated inventory management system using Microsoft Excel to streamline stock tracking and reporting for warehouse operations. The solution supported 10+ SKUs across two product categories and included features such as dynamic dashboards, automated alerts, and real-time stock monitoring. Advanced Excel functions (VLOOKUP, INDEX-MATCH, IF) were used for data linkage, while PivotTables and Power Pivot were employed for data aggregation and analysis. VBA macros were integrated to eliminate repetitive manual tasks, resulting in a 40% reduction in administrative workload and improved decision-making efficiency.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Inventory%20Management%20System%20(FIFO)%20In%20Excel.png?alt=media&token=b233113b-d7a9-4f7b-8b41-eaebbfe55b1c",
    tags: ["Inventory Management", "Advanced Excel Formula", "Automation Dashboarding", "Supply Chain Analytics"],
    category: "excel",
    slide: "https://www.canva.com/design/DAGqIga_BwQ/IyDZpfDu0_6Qza_Lp9SRyA/view?utm_content=DAGqIga_BwQ&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h24db81c602",
  },
  {
    id: 4,
    title: "Data Visualization - Case Study: Job Portal Demographic Dashboard",
    date: " Oct 2023",
    description:
      "Built an interactive demographic dashboard using Looker Studio to visualize and analyze job portal user data. Implemented slicers and dynamic visuals to allow real-time filtering by age group, education level, region, and employment status. The dashboard enabled recruiters to better understand user demographics and optimize their talent targeting strategies. Improved data clarity and decision-making by transforming raw data into actionable insights.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/TSA%20Hands%20On%20Project.png?alt=media&token=10ff83d9-58e6-4112-8e4c-4b3291b77185",
    tags: ["Looker Studio", "Business Intelligence", "Job Portal Analytics", "Demographic Analysis"],
    category: "bi",
    github: "https://github.com/filbertleo88/Digitalent-TSA-Projects/tree/ef772ee0a73fe103ab086c50b8ec364a6d52c822/Data%20Visualization",
    webapp: "https://lookerstudio.google.com/reporting/8a3ed927-11e9-46a0-a4eb-0c30938e3e95",
  },
  {
    id: 22,
    title: "Logistics Management & Geospatial Route Planning with Python",
    date: "Aug 2025",
    description:
      "Completed an advanced course on optimizing logistics operations and route planning using Python, geospatial libraries (GeoPandas, Folium), and optimization algorithms. Implemented a real-world project that analyzed delivery points, calculated optimal routes considering distance and traffic, and visualized results on interactive maps. Gained hands-on skills in data cleaning, spatial analysis, and performance evaluation to improve operational efficiency in logistics scenarios.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Logistics%20Management%20%26%20Geospatial%20Route%20Planning%20with%20Python.png?alt=media&token=db6d94aa-decb-4df2-87b6-0156549acc92",
    tags: ["Python", "GeoPandas", "Folium", "Route Optimization", "Logistics", "Data Visualization", "Geospatial Analysis"],
    category: "ai",
    slide: "https://www.canva.com/design/DAGvwsBJgt4/1YuTLfV1wL3d0uK5QXG3Nw/view?utm_content=DAGvwsBJgt4&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h26f48ae457",
  },
  {
    id: 7,
    title: "Learn SQL with 100 Coding Exercises",
    date: "June 2025",
    description:
      "Completed a hands-on SQL learning project by solving 100 real-world coding exercises. Practiced essential SQL concepts such as SELECT statements, JOINs, aggregate functions, subqueries, and data filtering. Gained strong proficiency in querying relational databases and analyzing structured data using SQL.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Learn%20SQL%20with%20100%20Coding%20Exercises.png?alt=media&token=dbe6fb8c-ddf1-48a7-bed6-1fa817d27710",
    tags: ["SQL", "Database Management"],
    category: "db",
    slide: "https://www.canva.com/design/DAGuQZKiiGc/angdMY-l8nYN-W8bSEdr1w/view?utm_content=DAGuQZKiiGc&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h8fb4710c98",
  },
  {
    id: 3,
    title: "Cilacap Flood Prediction",
    date: "Oct 2023 - Nov 2023",
    description:
      "Developed a Streamlit web dashboard application, which focuses on predicting flood risks in the Cilacap region. The prediction is based on daily hourly rainfall data, utilizing advanced algorithms to analyze weather patterns and forecast potential flooding. This application aims to provide local authorities and residents with timely alerts and actionable insights, helping them prepare and respond effectively to flood risks. The dashboard offers a user-friendly interface, making it easy to visualize rainfall data and prediction results. ",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Cilacap%20Flood%20Prediction.png?alt=media&token=0fc26986-42c4-4454-bb1f-38a123d95ac7",
    tags: ["Python", "Sklearn", "Statsmodels", "Plotly", "Joblib", "Streamlit"],
    category: "ai",
    github: "https://github.com/filbertleo88/TSA-Project-Dashboard-Pemantauan-dan-Prediksi-Banjir-Berbasis-Curah-Hujan-di-Kabupaten-Cilacap",
    webapp: "https://filbertleo88-tsa-project-dashboard-pemantauan-dan-p-main-iyns28.streamlit.app/",
    member: [
      {
        name: "Filbert Leonardo",
        img: "https://avatars.githubusercontent.com/u/101468273?v=4",
        linkedin: "https://www.linkedin.com/in/filbert-leonardo/",
        github: "https://github.com/filbertleo88",
      },
      {
        name: "Alfito Putra Fajar Pratama",
        img: "https://media.licdn.com/dms/image/v2/D5635AQFq-o51q5tq_A/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1693279664457?e=1725386400&v=beta&t=L2XTbBBtqLAQ_Oh5UrpkHk94A9E33oHwpElO1AxscgY",
        linkedin: "https://www.linkedin.com/in/alfitoptr/",
        github: "https://github.com/alfitoptr",
      },
      {
        name: "Muhammad Zia Ulhaq",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQHtitNis5_Fog/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1709893738557?e=1730332800&v=beta&t=SYIklfc8OPpZ_9ZSXv5Gt-cSACVtZ7nCs_tSuUDosfs",
        linkedin: "https://www.linkedin.com/in/muhammad-zia-ulhaq-8373112b9/",
      },
      {
        name: "Muhammad Bayu Fadayan",
        img: "https://media.licdn.com/dms/image/v2/D5603AQEGa0ASFi2nGQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1693895167780?e=1730332800&v=beta&t=mGpyVoGRQKR5EL8sw2eT8pTt3W0bVRrGBaLf4RUhWU4",
        linkedin: "https://www.linkedin.com/in/muhamad-bayu-fadayan",
        github: "https://github.com/bayufadayan",
      },
      {
        name: "Siti Ayuni",
        img: "https://avatars.githubusercontent.com/u/92244072?v=4",
        linkedin: "https://www.linkedin.com/in/sitiayuni25/",
        github: "https://github.com/sitiayuni",
      },
      {
        name: "Amanda Febrianti",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQFVBnTW8yB9oA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1683063591135?e=1730332800&v=beta&t=ylOnWuI_FqIjFd5ckRqU3DSJyo8wNbnicBeBxnGaXms",
        linkedin: "https://www.linkedin.com/in/amanda-febrianti/",
      },
    ],
  },
  {
    id: 1,
    title: "GreatEdu Hands On Projects (Customer Segmentation Using RFM & K-Means Clustering)",
    date: "Feb 2024 - May 2024",
    description:
      "This collection features hands-on projects focused on data science, encompassing various aspects such as data analysis, machine learning, and predictive modeling. Each project offers practical experience with essential data science methodologies and tools, providing insight into real-world applications and enhancing problem-solving skills within the domain.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Greatedu%20Hands-on%20Project.png?alt=media&token=3591dd70-7835-4556-bdd4-39bd35aa0865",
    tags: ["Python", "Database", "Deployment", "Data Preprocessing", "Data Exploration", "Machine Learning"],
    category: "ai",
    github: "https://github.com/filbertleo88/MSIB-GreatEdu-Projects",
    slide: "https://www.canva.com/design/DAGoKX7BACk/Eft4jAFDhe1Z4RVtzG0-sQ/view?utm_content=DAGoKX7BACk&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h243c8e2d29",
  },
  {
    id: 5,
    title: "Supervised Learning - Case Study: Telco Churn Prevention",
    date: "Oct 2023",
    description:
      "Developed a predictive model to identify potential customer churn for a telecommunications company. Conducted thorough data cleaning, encoding, and feature engineering to prepare the dataset for modeling. Applied classification algorithms including Logistic Regression, Random Forest, and XGBoost, with performance evaluated using F1-score and ROC-AUC. Identified key churn indicators such as contract type, tenure, and service usage patterns. Delivered actionable insights via confusion matrix and feature importance plots, enabling proactive retention strategies.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Supervised%20Learning%20Case%20Study%20Telco%20Churn%20Prevention.png?alt=media&token=97ccb76c-6578-4f2d-8993-1334134ee95f",
    tags: ["R", "Classification Models", "Feature Engineering", "Churn Analysis", "Customer Retention"],
    category: "ai",
    github: "https://github.com/filbertleo88/Digitalent-TSA-Projects/tree/ef772ee0a73fe103ab086c50b8ec364a6d52c822/Supervised%20Learning",
    slide: "https://www.canva.com/design/DAGoKXxHTYA/e0sHkP-eBDsNcoukUPHdGw/view?utm_content=DAGoKXxHTYA&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=haf6e3aaa4a",
  },
  {
    id: 6,
    title: "Unsupervised Learning - Case Study : Customer Segmentation",
    date: "Oct 2023",
    description:
      "Implemented an unsupervised learning approach to segment customers based on behavioral patterns using K-Means clustering. Conducted data preprocessing, feature scaling, and dimensionality reduction with PCA to improve clustering performance. Evaluated optimal cluster count using the Elbow Method and Silhouette Score, then grouped customers into distinct segments to support personalized marketing strategies. Visualized cluster insights with Seaborn and Plotly to assist stakeholder understanding and actionable targeting.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/K-Means%20Clustering.png?alt=media&token=78729421-58ec-4270-9a47-325dc97ef9ed",
    tags: ["R", "Clustering Evaluation", "Customer Segmentation", "Silhouette Score", "Marketing Analytics"],
    category: "ai",
    github: "https://github.com/filbertleo88/Digitalent-TSA-Projects/tree/ef772ee0a73fe103ab086c50b8ec364a6d52c822/Unsupervised%20Learning",
    slide: "https://www.canva.com/design/DAGoKXhK7ZQ/x8L9dtGCI_i_IM3vt_emqg/view?utm_content=DAGoKXhK7ZQ&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hbafb8beabc",
  },
  {
    id: 8,
    title: "Time Series & Forecasting - Case Study : TMA Laut Marina Ancol",
    date: "Oct 2023",
    description:
      "Developed a time series forecasting model to predict sea level trends at Marina Ancol for improved coastal planning. After comparing multiple models, selected SARIMA(2,0,2)(1,1,0)[24] as the final model due to its superior performance. The SARIMA 2 model achieved the lowest error on the test set with a MAPE of 14.80% (≈ 85% accuracy), making it suitable for short-term sea level forecasting. This project demonstrated the practical application of seasonal time series models in environmental and urban infrastructure contexts.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Time%20Series%20%26%20Forecasting.png?alt=media&token=a506c733-25f9-44d9-9958-48ae15c71596",
    tags: ["R", "Coastal Monitoring", "Decomposition", "PACF", "ACF"],
    category: "ai",
    github: "https://github.com/filbertleo88/Digitalent-TSA-Projects/tree/ef772ee0a73fe103ab086c50b8ec364a6d52c822/Time%20Series%20%26%20Forecasting",
    slide: "https://www.canva.com/design/DAGoKXm_NEg/eHTATYtff8YzlchcrIXFaQ/view?utm_content=DAGoKXm_NEg&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h2397d3b477",
  },
  {
    id: 9,
    title: "InterstateNow",
    date: "May 2023 - Jul 2023",
    description:
      "InterstateNow is an Android application designed to monitor the real-time capacity of rest areas by leveraging object detection technology. The app counts the number of vehicles entering and exiting rest areas using camera feeds. This data is then transmitted to the cloud, where it is processed and displayed on a dashboard. The dashboard provides PT Jasa Marga with a comprehensive view of rest area occupancy, enabling informed decision-making in managing traffic flow and optimizing rest area usage.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/InterstateNow%20Mobile.png?alt=media&token=a9709dce-be4a-4263-8335-950938e0c5a8",
    tags: ["YOLOv8", "Python", "Firebase", "Node Js", "Figma", "Android Studio", "Kotlin", "Docker"],
    category: "android",
    github: "https://github.com/filbertleo88/Bangkit_Capstone-Vehicle_Counting_Detection",
    slide: "https://docs.google.com/presentation/d/1q--ANZooly28UBNHD-mTv-DNurebgeQVm0fpz5wiBEo/edit?usp=sharing",
    webapp: "https://drive.google.com/file/d/1r6zUo2fib771zaGVRp3Xbji9Yrqjw51e/view",
    member: [
      {
        name: "Filbert Leonardo",
        img: "https://avatars.githubusercontent.com/u/101468273?v=4",
        linkedin: "https://www.linkedin.com/in/filbert-leonardo/",
        github: "https://github.com/filbertleo88",
      },
      {
        name: "Abraham Mauritz Talakua",
        img: "https://media.licdn.com/dms/image/v2/D5603AQHNpYRp8rj3LQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1722435790564?e=1730332800&v=beta&t=HjX9xKuB1zlGYkTtboIU2PArQJhUcJU0T3qPsJuPrL8",
        linkedin: "https://www.linkedin.com/in/amauritzt/",
        github: "https://github.com/mauritzmauritz",
      },
      {
        name: "Fajrul Kamal",
        img: "https://media.licdn.com/dms/image/v2/C4D03AQHLoggXcryMNQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1642860654859?e=1730332800&v=beta&t=AVqOWDtUdormldAIb2Vft_YZnD0lZ-AVf9JziQeT-GQ",
        linkedin: "https://www.linkedin.com/in/fajrul-kamal-9a1038230/",
        github: "https://github.com/fajrulkamal",
      },
      {
        name: "Ken Diani Mutia Sari",
        img: "https://media.licdn.com/dms/image/v2/D5635AQE1OsmYtE_R0g/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1705641307434?e=1725379200&v=beta&t=Qg4UYKYgDqhwmJtGDi0I-KN2KpTS621Q_5e8fdyqcNw",
        linkedin: "https://www.linkedin.com/in/ken-diani/",
        github: "https://github.com/candycrushonly",
      },
      {
        name: "Muhammad Ghiffari",
        img: "https://media.licdn.com/dms/image/v2/D5635AQFAGvoP6OxHFQ/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1724661641351?e=1725379200&v=beta&t=Vs0w4k1rrqsHP7FIHLvzSayXrUdYMBdLvRxi1sQq990",
        linkedin: "https://www.linkedin.com/in/ghips/",
        github: "https://github.com/gipsidipsi",
      },
      {
        name: "Jeremy Diaz Prasetyo",
        img: "https://avatars.githubusercontent.com/u/90140304?v=4",
        linkedin: "https://www.linkedin.com/in/jeremydiazp/",
        github: "https://github.com/0rganic",
      },
    ],
  },
  {
    id: 10,
    title: "MyShoes",
    date: "Oct 2022 - Feb 2023",
    description:
      "MyShoes is a Android application designed as an e-commerce platform specifically for selling various types and brands of branded shoes. This application allows users to browse, select, and purchase high-quality footwear from a wide range of options. Developed as a college mobile android project, MyShoes focuses on providing a seamless shopping experience with a user-friendly interface, making it easy for customers to find and buy their desired shoes online.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/MyShoes%20Mobile.png?alt=media&token=6eab595f-7d3e-43f3-b9d4-49cdc3035729",
    tags: ["Java", "Android", "Firebase", "Firestore"],
    category: "android",
    github: "https://github.com/filbertleo88/MyShoes",
    webapp: "https://github.com/filbertleo88/MyShoes",
  },
  {
    id: 11,
    title: "Eat2Day",
    date: "Jun 2022 - Jul 2022",
    description:
      "Eat2Day is a web application designed as part of a college web programming project. The application serves as a restaurant website, providing detailed information about the menu, including both food and drink options. This project focuses solely on the frontend development, showcasing the layout, design, and user interface features that make it easy for visitors to browse through the menu offerings.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Eat2Day%20Website.png?alt=media&token=4d8ce67e-9e9c-447f-b662-49495ab8de29",
    tags: ["HTML", "CSS", "Javascript", "Bootstrap"],
    category: "web",
    github: "https://github.com/filbertleo88/eat2dayrestaurant",
  },
  {
    id: 12,
    title: "Personal Website",
    date: "Mar 2022 - Apr 2022",
    description:
      "Developed a personal website as part of a web programming course assignment. The website showcases a portfolio of work, personal projects, and relevant information about academic and professional experiences. It serves as an online resume, featuring sections like an about page, project gallery, blog, and contact form, all designed to highlight skills in web development and design. The project emphasizes responsive design, user experience, and modern web technologies.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Personal%20Website%20.png?alt=media&token=99a67d56-d206-47a5-8304-599fba5fe5ae",
    tags: ["HTML", "CSS", "Javascript", "Bootstrap"],
    category: "web",
    github: "https://github.com/filbertleo88/PersonalWebsite",
    webapp: "https://filbertleo88.github.io/PersonalWebsite/",
  },
  {
    id: 13,
    title: "Facebook Clone 1",
    date: "Oct 2021 - Dec 2021",
    description:
      "Developed a new website layout for Facebook as part of a web programming course project. This project focuses on redesigning the user interface (UI) to enhance usability, functionality, and aesthetics. The goal is to create a more modern and responsive user experience, showcasing key features like the homepage, profile, notifications, and messaging with a fresh look. The project emphasizes the use of the latest web technologies and best practices in frontend development.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Facebook%20Website%201.png?alt=media&token=3f30515c-e2f3-40e4-bf9f-289632acef89",
    tags: ["HTML", "CSS", "Javascript", "Bootstrap"],
    category: "web",
    github: "https://github.com/filbertleo88/FacebookProject1",
    webapp: "https://filbertleo88.github.io/FacebookProject1/",
  },
  {
    id: 14,
    title: "Facebook Clone 2",
    date: "Jun 2021 - Aug 2021",
    description:
      "Developed a new website layout for Facebook as part of a web programming course project. This project focuses on redesigning the user interface (UI) to enhance usability, functionality, and aesthetics. The goal is to create a more modern and responsive user experience, showcasing key features like the homepage, profile, notifications, and messaging with a fresh look. The project emphasizes the use of the latest web technologies and best practices in frontend development.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Facebook%20Website%202.png?alt=media&token=016b1ab7-1d9b-4d62-9d12-bc81ff909a6c",
    tags: ["HTML", "CSS", "Javascript", "Bootstrap"],
    category: "web",
    github: "https://github.com/filbertleo88/FacebookProject2",
    webapp: "https://filbertleo88.github.io/FacebookProject2/",
  },
  {
    id: 15,
    title: "Zero to Hero in Microsoft Excel: Complete Excel Guide 2025",
    date: "May 2025",
    description:
      "This intensive course is designed to build end-to-end Excel proficiency. Covered foundational to expert-level skills including advanced formulas, PivotTables, data visualization, conditional formatting, and real-world business problem solving. Gained hands-on experience with dynamic dashboards, data analysis techniques, and workflow automation using formulas and functions. The course emphasized practical Excel use cases relevant to finance, operations, and reporting.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Zero%20to%20Hero%20in%20Microsoft%20Excel%20Complete%20Excel%20Guide%202025.png?alt=media&token=23e41414-62eb-4a6d-bb0c-88daa3c49977",
    tags: ["Logical Formulas", "Lookup Formulas", "Pivot Tables", "Charts", "VBA Macros", "Analytics in Excel"],
    category: "excel",
    slide: "https://www.canva.com/design/DAGqItI78H8/06pMx7XvLHPpMp2mGszm7Q/view?utm_content=DAGqItI78H8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h5f1ff1ad11",
  },
  {
    id: 16,
    title: "Microsoft Excel: Learn Excel by Creating Diverse Projects",
    date: "May 2025",
    description:
      "This is a project-based course focused on practical Excel applications through real-world scenarios. Gained hands-on experience building interactive spreadsheets, automating tasks, and analyzing business data. Projects covered areas such as budget tracking, inventory management, sales dashboards, and dynamic reporting. Strengthened skills in formula logic, data visualization, conditional formatting, and structured workbook design for business use cases.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Microsoft%20Excel%20-Basic%20Excel%20Advanced%20Excel%20Formulas.png?alt=media&token=77a9c35c-fd87-42bf-83d5-e71c7cdc3cab",
    tags: ["Data Entry and Exploration", "Formatting and Presenting Data", "Creating Charts and Tables"],
    category: "excel",
    slide: "https://www.canva.com/design/DAGqIoYzG8E/373iM4-PefBoqbB2lqx3UQ/view?utm_content=DAGqIoYzG8E&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h2ff15cd223",
  },
  {
    id: 17,
    title: "Microsoft Excel - Beginner to Advance with Example",
    date: "Apr 2025",
    description:
      "This is a comprehensive course covering essential to advanced Excel functionalities through real-life examples. Developed expertise in spreadsheet operations, complex formula building, and data organization. The course emphasized efficiency in tasks such as data entry, calculations, charting, and reporting. Also learned to automate repetitive processes and create structured workbooks for business and analytical use.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Microsoft%20Excel%20-%20Beginner%20to%20Advance%20with%20Example.png?alt=media&token=df8ed84b-6b46-4f0d-a07c-e8336e0ab3cd",
    tags: ["Analytical dashboard creation", "Data Validation", "Conditional Formatting", "Data Filtering"],
    category: "excel",
    slide: "https://www.canva.com/design/DAGqIic_9o8/8QByUUIYTaQX3yl37LXIbQ/view?utm_content=DAGqIic_9o8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h9d17b7990f",
  },
  {
    id: 19,
    title: "Inventory Management tools for Supply Chain Planning",
    date: "May 2025",
    description:
      "This course equips learners with essential inventory management skills, combining theory and hands-on Excel analysis. It covers inventory planning, cost optimization, selective control methods (ABC, XYZ, etc.), replenishment strategies, and performance metrics. Designed by industry and academic experts, the course provides ready-made templates and real-world case studies to help streamline operations, reduce costs, and enhance supply chain performance.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Inventory%20Management%20tools%20for%20Supply%20Chain%20Planning.png?alt=media&token=7c35caab-9059-481f-9c0b-3f9cc7a5fbca",
    tags: ["Inventory Management", "Supply Chain Analytics", "Selective Control Methods", "Replenishment Strategies", "KPI Performance Metrics"],
    category: "excel",
    slide: "https://www.canva.com/design/DAGqyBlckIE/FLhSZBHNwbjaFz_L5xtYmA/view?utm_content=DAGqyBlckIE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h40bc4d409a",
  },
  {
    id: 20,
    title: "Population and Healthcare Facilities Dashboard in West Java",
    date: "Jan 2024 - Jan 2024",
    description:
      "This dashboard presents comprehensive information on the distribution of the population and healthcare facilities across the region. This dashboard provides data-driven insights that allow users to analyze population density, access to healthcare services, and the availability of medical facilities.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Revou%20Final%20Project.png?alt=media&token=234bada1-4ff9-49c6-9dcb-ee26f526202e",
    tags: ["Database", "SQL", "Data Exploration", "Data Visualization", "Tableau"],
    category: "bi",
    github: "https://github.com/filbertleo88/Revo-U-Final-Project",
    slide: "https://docs.google.com/presentation/d/1DF0KkTOS39lfOcA0Kj8Fz5z9mPTuz8Ck/edit?usp=sharing&ouid=100577205516449872153&rtpof=true&sd=true",
    webapp: "https://public.tableau.com/app/profile/filbert.leonardo/viz/DashboardJumlahPendudukdanFaskesdiJawaBarat/Dashboard1",
  },
  {
    id: 21,
    title: "Text Classification - Case study : Hate Speech twitter",
    date: "Oct 2023",
    description:
      "Built a text classification pipeline to detect hate speech in tweets using three different feature extraction and modeling approaches. Preprocessed text data with tokenization, stopword removal, and normalization. Implemented Bag of Words (BoW) and TF-IDF vectorization techniques, both paired with Random Forest classifiers, achieving strong baseline performance. Further enhanced model accuracy using a Convolutional Neural Network (CNN) with TensorFlow for deep semantic learning. Evaluated models using accuracy, precision, recall, and F1-score to determine optimal deployment strategy.",
    image: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-db8f9.appspot.com/o/Text%20Classification.png?alt=media&token=d5a10f60-eb6c-4dde-a5bd-1101af4b14a6",
    tags: ["R", "NLP", "Hate Speech Detection", "Bag of Words", "TF-IDF", "Tensorflow"],
    category: "ai",
    github: "https://github.com/filbertleo88/Digitalent-TSA-Projects/tree/ef772ee0a73fe103ab086c50b8ec364a6d52c822/Text%20Classification",
    slide: "https://www.canva.com/design/DAGoKV4nXoQ/d_jntg5pEOKGxU-NGF2JOA/view?utm_content=DAGoKV4nXoQ&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h26ca0e1ddf",
  },
];
